import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/services/event.service';
import { PopupService } from 'src/app/services/popup.service';
import { languages } from 'src/app/shared/constants/app-enums';
import { environment } from 'src/environments/environment';
export var selectedLang: string;
@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent {
  contactForm!: FormGroup;
  isSubmitted = false;
  currentLanguage: any;
  languagesList: Array<any> = languages;
  constructor(
    private http: HttpClient,
    private popupService: PopupService,
    private router: Router,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private eventService: EventService,
  ) {

    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.contactForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_REGEXP)]],
      firstname: ['', Validators.required],
      url: ['', Validators.required],
      lastname: ['', Validators.required],
      more_info: ['']
    });


    selectedLang = this.eventService.getNewLang() || 'en';


  }

  ngOnInit(): void {
    console.log("selected lang", selectedLang);
    this.translate.setDefaultLang(selectedLang);
    this.translate.use(selectedLang);
    this.eventService.setLang(selectedLang);
    if (!this.currentLanguage) {
      this.currentLanguage = selectedLang;
      selectedLang = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    }

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }

  get f() { return this.contactForm.controls; }

  onSubmit() {
    if (this.isSubmitted)
      return;
    if (this.checkForm()) {
      let req = this.contactForm.value;
      req.iid = environment.partnerListId;
      this.http.post(environment.partnerListURL, req).subscribe((res) => {
        this.isSubmitted = true;
        this.popupService.messagePopup("success", this.translate.instant("formSuccess")).then(() => {
          this.router.navigate(['/']);
        });
      },
        (err) => {
          this.popupService.messagePopup("error", this.translate.instant("formError"));
        });
      //do something
    }
  }

  checkForm(): boolean {
    this.contactForm.updateValueAndValidity();
    if (this.f['email'].errors || this.f['firstname'].errors || this.f['lastname'].errors || this.f['url'].errors || this.f['more_info'].errors) {
      return false;
    }
    return true;
  }
}
